import { render } from "./Dashboard.vue?vue&type=template&id=097ba13b"
import script from "./Dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "097ba13b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('097ba13b', __exports__)) {
    api.reload('097ba13b', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=097ba13b", () => {
    api.rerender('097ba13b', render)
  })

}


export default __exports__